import useSWRImmutable from 'swr/immutable'

import { getBillingPortalUrl } from '../../../api/payment'
import Loading from '../../components/layout/Loading'
import ErrorMessage from '../../components/errors/ErrorMessage'

const BillingPortalPage = () => {
  const { data, isLoading, error } = useSWRImmutable('/billing/url', getBillingPortalUrl)
  if(isLoading) { return <Loading size='fill-container' /> }
  if(error) { return <ErrorMessage message={error.message} /> }
  if(!data) { return <ErrorMessage message={'Billing portal url is empty'} /> }
  window.location.replace(data)
  return <Loading size='fill-container' />
}

export default BillingPortalPage
